// Source of truth for the Privacy Policy shown at /privacy-policy.
// Edit THIS file to change the policy text - no component/layout code
// needs to change. Keep the '**Last Updated: ...**' line current whenever
// the content meaningfully changes.
const privacyPolicyContent = `# Privacy Policy

**Last Updated: July 31, 2026**

## 1. Introduction

This Privacy Policy explains how Justice Genie ("Justice Genie," "we," "our," or "us") collects, uses, and protects information when you use our AI-powered legal information platform (the "Service"). Justice Genie is independently developed and operated by Yaganti Subhash and Vemula Siri Mahalaxmi.

By creating an account or otherwise using the Service, you agree to the practices described in this Policy.

## 2. Information We Collect

**Information you provide directly**
- Username, email address, and password (stored as a secure, irreversible hash)
- Your selected profession
- If you sign in with Google: your name, email address, and profile picture, as shared with us by Google

**Information generated through your use of the Service**
- Questions submitted and responses received through the AI assistant ("chat history")
- Case-strength analysis requests and results
- Quiz activity, scores, and leaderboard standing
- Feedback submitted through the platform

**Technical information**
- Session identifiers used to keep you signed in
- Basic technical data such as IP address and browser type, used for security and service reliability

**Cookies**
The Service uses only essential, functional cookies required to maintain your session. We do not use advertising or cross-site tracking cookies.

## 3. How We Use Information

We use collected information to:
- Provide and operate the Service
- Authenticate users and maintain account security
- Detect, prevent, and respond to fraud, abuse, and security incidents
- Send essential account-related communications (such as verification and password-reset messages)
- Improve the reliability, performance, and functionality of the Service
- Comply with applicable legal obligations

We do not sell personal information, and we do not use your information for advertising.

## 4. AI Processing

Questions and content you submit to the Service may be processed by one or more third-party AI providers in order to generate a response. These providers process data under their own terms and privacy practices, independent of this Policy.

We recommend avoiding the submission of highly sensitive personal information — such as government identification numbers, exact financial details, or identifying information about third parties — when using the AI assistant.

## 5. Third-Party Service Providers

We rely on trusted third-party providers to operate the Service, including:

| Category | Purpose |
|---|---|
| **AI Providers** | Generate responses to user questions and analysis requests |
| **Authentication Providers** | Support account sign-in, including Google Sign-In |
| **Cloud Hosting Providers** | Host the Service's application and infrastructure |
| **Cloud Storage Providers** | Store documents and images used by the Service |
| **Email Service Providers** | Deliver account-related transactional email |

Each provider processes data solely to the extent necessary to deliver their respective service to us.

## 6. Data Retention

We retain account and usage information for as long as your account remains active. Chat history is retained until you clear it or delete your account. Verification and password-reset codes expire automatically after a limited time and are not retained beyond that period. Upon account deletion, associated personal data is permanently removed from our active systems.

## 7. Security

We apply industry-standard technical and organizational safeguards designed to protect information from unauthorized access, alteration, or disclosure. No method of transmission or storage can be guaranteed as completely secure, but we actively maintain and improve these safeguards.

## 8. Your Rights and Choices

You may, at any time:
- Access and update your account information
- Clear your chat history
- Delete your account, which permanently removes associated personal data
- Contact us with any question or concern regarding your information

## 9. Children's Privacy

The Service is intended for users aged 18 and older. We do not knowingly collect information from individuals under 18. If we become aware that a minor has created an account, we will take steps to remove it.

## 10. International Data Transfers

Certain third-party providers we rely on may process or store information on servers located outside your country of residence. By using the Service, you consent to this transfer where necessary to provide the Service.

## 11. Changes to This Policy

We may update this Privacy Policy from time to time to reflect changes in our practices or for legal or operational reasons. Material changes will be reflected by updating the date above. Continued use of the Service after changes constitutes acceptance of the updated Policy.

## 12. Contact Us

Questions regarding this Privacy Policy may be directed to:

**justicegenie2.0@gmail.com**
`;

export default privacyPolicyContent;
